;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/edit/:id\",\"regex\":\"^/edit/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/preview/:id\",\"regex\":\"^/preview/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/settings/profile/:user-profile*?\",\"regex\":\"^/settings/profile(?:/(.*))?$\",\"paramNames\":[\"user-profile\"],\"hasOptionalPrefix\":false},{\"path\":\"/story/:scope\",\"regex\":\"^/story/([^/]+)$\",\"paramNames\":[\"scope\"],\"hasOptionalPrefix\":false},{\"path\":\"/timeline/:id\",\"regex\":\"^/timeline/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/event/:id\",\"regex\":\"^/event/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/event-manager-invite/:token\",\"regex\":\"^/event-manager-invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/invite/:token\",\"regex\":\"^/invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/sign-in/:sign-in*?\",\"regex\":\"^/sign-in(?:/(.*))?$\",\"paramNames\":[\"sign-in\"],\"hasOptionalPrefix\":false},{\"path\":\"/sign-up/:sign-up*?\",\"regex\":\"^/sign-up(?:/(.*))?$\",\"paramNames\":[\"sign-up\"],\"hasOptionalPrefix\":false},{\"path\":\"/workspace-invite/:token\",\"regex\":\"^/workspace-invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/attending\"},{\"path\":\"/create\"},{\"path\":\"/events\"},{\"path\":\"/guide\"},{\"path\":\"/memories\"},{\"path\":\"/settings\"},{\"path\":\"/settings/billing\"},{\"path\":\"/settings/members\"},{\"path\":\"/settings/notifications\"},{\"path\":\"/timeline\"},{\"path\":\"/\"},{\"path\":\"/pricing\"},{\"path\":\"/demo\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.3";import * as Sentry from "@sentry/nextjs"

import {
  getBrowserSentryDsn,
  getReplayOnErrorSampleRate,
  getReplaySessionSampleRate,
  getSentryEnvironment,
  getSentryRelease,
  getTracesSampleRate,
  isSentryRuntimeEnabled,
  shouldDropNoisySentryEvent,
  stripRequestPii,
} from "@/lib/sentry/config"

const dsn = getBrowserSentryDsn()

Sentry.init({
  dsn: dsn || undefined,
  enabled: isSentryRuntimeEnabled(dsn),
  environment: getSentryEnvironment(),
  release: getSentryRelease(),
  tracesSampleRate: getTracesSampleRate(),
  replaysSessionSampleRate: getReplaySessionSampleRate(),
  replaysOnErrorSampleRate: getReplayOnErrorSampleRate(),
  integrations: [Sentry.replayIntegration()],
  maxBreadcrumbs: 30,
  sendDefaultPii: false,
  beforeSend(event) {
    if (shouldDropNoisySentryEvent(event)) return null
    return stripRequestPii(event)
  },
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
